/** Shared by calendar buttons and server-rendered filter links. */
export function dateFilterChipClassName(active: boolean) {
  return `cursor-pointer rounded-md border px-3 py-1.5 font-mono text-xs transition-colors ${active
    ? "border-acid bg-acid text-black"
    : "border-neutral-700 text-neutral-400 hover:border-neutral-500 hover:text-neutral-300"}`;
}

